import CommonAppbar from '../components/common/CommonAppbar';
import ProfileOverview from '../components/ProfileOverview';
import * as React from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StarIcon from '@mui/icons-material/Star';
import InfoIcon from '@mui/icons-material/Info';
import ShareIcon from '@mui/icons-material/Share';
import WorkIcon from '@mui/icons-material/Work';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import LanguageIcon from '@mui/icons-material/Language';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import {URLS} from '../constants/appConstants';
import {useNavigate} from 'react-router-dom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DeveloperInfo from "../components/common/DeveloperInfo";

const profileConfig = [
  {
    name: 'Coins(V2)',
    icon: <AccountBalanceWalletIcon/>,
    componentUrl: URLS.COINS_DASHBOARD
  }, {
    name: 'Notification settings',
    icon: <EditNotificationsIcon/>,
    componentUrl: URLS.PROFILE_NOTIFICATION_SETTINGS
  },
  {
    name: 'Display Language',
    icon: <LanguageIcon/>,
    componentUrl: URLS.LANGUAGE_SELECTION
  },
  {
    name: 'Content Language',
    icon: <LanguageIcon/>,
    componentUrl: URLS.CONTENT_LANGUAGE_SELECTION
  },
  {
    name: 'Rate us',
    icon: <StarIcon/>,
    link: 'https://play.google.com/store/apps?hl=en&gl=US'
  },
  {
    name: 'About us',
    icon: <InfoIcon/>,
    link: 'https://example.com/'
  },
  {
    name: 'Share App',
    icon: <ShareIcon/>,
    componentUrl: ''
  },
  {
    name: 'Hiring',
    icon: <WorkIcon/>,
    link: 'https://example.com/'
  },
  {
    name: 'Privacy policy',
    icon: <PrivacyTipIcon/>,
    componentUrl: URLS.PRIVACY_POLICY,
    link: 'https://example.com/'
  },
  {
    name: 'Child Safety policy',
    icon: <PrivacyTipIcon/>,
    componentUrl: URLS.CHILD_POLICY,
    link: 'https://example.com/'
  }
]
export default function Profile() {
  const navigate = useNavigate();
  const renderProfileItems = () => {
    return <List>
      {profileConfig.map(pc => {
        const {name, icon, link, componentUrl} = pc
        return <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              {icon}
            </ListItemIcon>
            <ListItemText primary={name} onClick={() => {
              if (componentUrl) {
                navigate(componentUrl)
                return
              }
              if (link) {
                window.location.href = link
              }
            }}/>
          </ListItemButton>
        </ListItem>
      })}
    </List>
  }

  return <>
    <CommonAppbar isMainPage={true} pageHeader={'Profile'}/>
    <ProfileOverview isCurrentUser={true}/>
    <DeveloperInfo> Coins and Monetization is not applicable for all apps</DeveloperInfo>
    {renderProfileItems()}
    <Stack divider={<Divider flexItem/>}>
      <Button variant="outlined" startIcon={<LogoutIcon/>} size={'small'} onClick={() => navigate(URLS.SIGN_IN)}>
        Logout
      </Button>
    </Stack>
  </>
}
